module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "RoomActions__wrapper"
  }, [_c('div', {
    staticClass: "RoomActions__container"
  }, [(_vm.user.isOwner) ? _c('i', {
    staticClass: "icon-ic_edit RoomActions__action-btn",
    on: {
      "click": _vm.setTitle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.isOwner) ? _c('i', {
    staticClass: "icon-ic_plus-circle RoomActions__action-btn",
    class: {
      'active': _vm.asideType === 'invite-menu'
    },
    on: {
      "click": function($event) {
        _vm.toggleAside('invite-menu')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "icon-ic_chat RoomActions__action-btn RoomActions__chat-icon",
    class: {
      'active': _vm.asideType === 'chat'
    },
    attrs: {
      "data-count": _vm.unreadMessagesCount
    },
    on: {
      "click": function($event) {
        _vm.toggleAside('chat')
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf4fae16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/room/room-actions/room-actions.vue
// module id = 435
// module chunks = 1